<template>
  <b-col class="mt-4" sm="3" md="3">
    <div class="content-center border stat-card">
      <h4 class="bg-lighter stat-text pt-3 pb-3">{{ title }}</h4>
      <h1 class="mt-4 mb-3 stat-title">
        <div class="icon-container">
            <img class="stat-icon" :src="getImgUrl()">
        </div>
        <br/>
        {{ number }}
      </h1>
    </div>
  </b-col>
</template>
<script>
export default {
  props: ["title", "number", "icon_filename"],
  methods:{
    getImgUrl() {
        var images = require.context('../../public/', false)
        return images('./' + this.icon_filename)
    }
  }
};
</script>

<style>
.stat-text {
  height: 80px;
  padding-left: 10px;
  padding-right: 10px;
  background-color: rgba(255, 255, 255, 0.8);
}

.stat-card {
  background-color: rgba(255, 255, 255, 0.5);
  height: 280px;
}

.stat-title {
  font-size: 350%;
}

.icon-container{
    position:absolute;
    width:90%;
    height:100px;
}

img.stat-icon {
  margin-left: auto;
  margin-right: auto;
  display: block;
}

</style>
